export default __webpack_public_path__ + "static/PADI-c36fd652acefad735866414459d12d11.svg";